import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Reusable component for a dropdown item
const DropdownItem = ({ text, link }) =>{

    const location = useLocation();
    const isActive = location.pathname === link;

return (
    <Link className={`dropdown-item ${isActive ? 'active' : ''}`} to={link}>
        {text}
    </Link>
);
}


const ReportsLink = () => {

    
    return (
        <li className="btn-group nav-item">
            <Link to='#' className="nav-link" data-toggle="dropdown" aria-expanded="false">
            <i className="nav-link-icon fa fa-chart-line"></i> Financial Reports
                <i className="fa fa-angle-down ml-2 opacity-5"></i>
            </Link>
            <div role="menu" className="rm-pointers dropdown-menu">
                <div className="scroll-area-xs-none">
                    <div className="scrollbar-container">
                        <DropdownItem text="Income Statement" link="/report-income-statement" />
                        <DropdownItem text="Trial Balance" link="/report-trial-balance" />
                        <DropdownItem text="Balance Sheet" link="/report-balance-sheet" />
                        <DropdownItem text="Financial Period" link="/report-financial-period" />

                    </div>
                </div>
            </div>
        </li>
    );
};

export default ReportsLink;
